<template>
  <div class="row">
    <b-col cols="12">
      <b-tabs content-class="mt-3">
        <!-- Text -->
        <b-tab
          title="Text"
          active
        >
          <b-tabs
            pills
            card
            vertical
          >
            <!-- Render Tabs, supply a unique `key` to each tab -->
            <b-tab
              @click="tabClick(language)"
              v-for="(language, index) in form.formTranslations"
              :key="index"
              :title="language"
            >
              <!-- translation form wrappe -->
              <div>
                <b-form-group label="Question">
                  <!-- @blur="addLanguageToField(language)" -->
                  <b-form-textarea
                    id="textarea"
                    v-model="fieldData.questionText[transalationLanguage]"
                    placeholder="Enter your question here...."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </div>
              <b-spinner
                small
                v-if="isLoadedNewKeys"
              ></b-spinner>
              <div v-else>
                <b-form-group label="Positive Message">
                  <!-- <b-form-textarea
                    v-model="fieldData.positiveMessage[transalationLanguage]"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea> -->

                  <wysiwyg v-model="fieldData.positiveMessage[transalationLanguage]" />
                </b-form-group>

                <b-form-group label="Negative Message">
                  <!-- <b-form-textarea
                    v-model="fieldData.negativeMessage[transalationLanguage]"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea> -->
                  <wysiwyg v-model="fieldData.negativeMessage[transalationLanguage]" />

                </b-form-group>
              </div>
              <!-- <b-button
								class="btn btn-primary mt-3"
								@click="addLanguageToField(language)"
								variant="primary"
							>
								<b-spinner small v-if="isLoading"></b-spinner>Update
              </b-button>-->
            </b-tab>
          </b-tabs>
        </b-tab>

        <b-tab title="Advanced">
          <b-row>
            <b-col cols="10">
              <h3 class="text-center">Advanced Options</h3>
              <!-- <b-form-group label="Question Type">
								<b-form-radio-group
									id="radio-group-1"
									v-model="selectedQuestionType"
									:options="optionsQuestionType"
									name="questionType"
								></b-form-radio-group>
              </b-form-group>-->
              <b-form-group label="Time Limit *">
                <b-input-group
                  append="Mins"
                  class="mb-1"
                >
                  <b-input
                    type="number"
                    v-model="questionTimeLimit"
                    name="questionTimeLimit"
                    placeholder="3"
                  ></b-input>
                </b-input-group>
              </b-form-group>

              <b-form-group label="score *">
                <b-input
                  type="number"
                  v-model="questionScore"
                  name="questionScore"
                ></b-input>
              </b-form-group>

              
                <b-form-group>
                  <b-form-checkbox
                    v-model="isCompulsory"
                    value="1"
                  >Is Complusory?</b-form-checkbox>
                </b-form-group>
              <!-- Start Background Image -->
              <div style="margin-top:10px;">
                <b-form-group>
                  <b-form-checkbox
                    v-model="isImageRequired"
                    value="1"
                  >Add Image to Question?</b-form-checkbox>
                </b-form-group>
              </div>
              <!-- file upload option -->
              <div v-if="isImageRequired">
                
                 <input ref="input" type="file" name="image" accept="image/*"  />

                    <b-form-file
											:value="file"
											:state="Boolean(file)"
											size="sm"
											:placeholder="'Choose image'"
											@input="addBackgroundImg($event)"
										  >
                    </b-form-file>

                  <div v-if="this.imgUrl != null">
                      <img v-bind:src=this.imgUrl alt="image" style="height:250px;" />
                  </div> 
                    

              </div>
              <!-- End Background Image -->

              <!-- <b-form-group label="Question Level">
								<b-form-radio-group
									v-model="selectedQuestionLevel"
									:options="optionsQuestionLevel"
									name="radio-options"
								></b-form-radio-group>
              </b-form-group>-->
            </b-col>
            <!-- <b-col cols="2">
							<b-button variant="outline-success" @click="updateAdvancedSettings">Update</b-button>
            </b-col>-->
          </b-row>
        </b-tab>

        <b-tab title="Anwsers">
          <b-row>
            <b-col cols="10">
              <h3 class="text-center">Answers Options</h3>

              <b-form-radio-group id="radio-group-2">
                <b-form-radio
                  name="questionOrderType"
                  v-model="questionAnswerOrderType"
                  value="1"
                >Show in current order</b-form-radio>
                <b-form-radio
                  name="questionOrderType"
                  v-model="questionAnswerOrderType"
                  value="2"
                >Shuffle answers</b-form-radio>
              </b-form-radio-group>

              <b-form-group label="Answer Input Type">
                <b-form-radio-group
                  v-model="selectedQuestionAnswerInputType"
                  :options="optionsQuestionAnswerInputType"
                  name="radio-options"
                ></b-form-radio-group>
              </b-form-group>

              <b-tabs
                pills
                card
                vertical
              >
                <b-tab
                  @click="tabClick(language)"
                  v-for="(language, index) in form.formTranslations"
                  :key="index"
                  :title="language"
                >
                  <div v-if="fieldData.answerTitle">
                    <b-form-group label="Answer *">
                      <!-- v-model="questionAnswer" -->

                      <b-form-textarea
                        v-if="
                          isEditingAnswer && transalationLanguage in ansTempObje
                        "
                        id="textarea"
                        v-model="tempAnsValue"
                        placeholder="Enter a possible answer here"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <b-form-textarea
                        v-else
                        id="textarea"
                        v-model="tempAnsValue"
                        placeholder="Enter a possible answer here"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <b-form-invalid-feedback>This is a required field and must be at least 5
                        characters.</b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </b-tab>
              </b-tabs>

              <b-form-checkbox
                value="1"
                :disabled="!tempAnsValue"
                v-model="questionAnswerIsCorrect"
              >Is Correct Answer?</b-form-checkbox>

              <b-form-row class="float-right">
                <b-button
                  variant="outline-warning"
                  class="mr-2"
                  @click="reset"
                >reset</b-button>
                <b-button
                  variant="outline-primary"
                  class="mr-2"
                  @click="addItemMultiChoice"
                >{{ isEditingAnswer ? "Edit" : "Add" }}</b-button>
              </b-form-row>
              <div class="clearfix"></div>

              <br />
              <b-table-simple>
                <thead>
                  <tr>
                    <th>Answer</th>
                    <th>Is Correct</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tr
                  v-for="(item, index) in answers"
                  :key="index"
                >
                  <td>{{ item.answer[transalationLanguage] }}</td>
                  <td>{{ item.isCorrectAnswer }}</td>
                  <td>
                    <font-awesome-icon
                      v-b-tooltip.hover
                      title="Delete Answer"
                      icon="trash"
                      :class="'ml-2 text-danger'"
                      @click="removeRowMultiChoice(index)"
                    />
                    <font-awesome-icon
                      v-b-tooltip.hover
                      title="Edit Answer"
                      class="ml-2 text-primary"
                      icon="edit"
                      @click="editAnswer(item, index, transalationLanguage)"
                    />
                  </td>
                </tr>
              </b-table-simple>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Attributes">
          <b-row>
            <b-col cols="8">
              <b-form-group
                v-if="fieldData.questionAttributes && fieldData.questionAttributes.length > 0"
                label="Key"
              >
                <b-form-input
                  @change="setTimeOutFunc"
                  size="sm"
                  v-model="fieldData.questionAttributes[fieldDataAttributeIndex].key"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              cols="4"
              class="m-auto"
            >
              <div style="margin-left:100px">
                <b-btn
                  class="float-left"
                  size="sm"
                  variant="outline-info"
                  @click="addDataAttribute"
                >

                  <i class="fa fa-plus"></i>
                </b-btn>
              </div>

            </b-col>

          </b-row>

          <b-tabs
            pills
            card
            vertical
          >
            <!-- Render Tabs, supply a unique `key` to each tab -->

            <b-tab
              @click="tabClick(language)"
              v-for="(language, index) in form.formTranslations"
              :key="index"
              :title="language"
            >
              <!-- translation form wrappe -->
              <b-form-group
                label="Value"
                v-if="fieldData.questionAttributes && fieldData.questionAttributes.length > 0"
              >
                <b-form-input
                  size="sm"
                  @change="setTimeOutFunc"
                  v-model="fieldData.questionAttributes[fieldDataAttributeIndex].value[transalationLanguage]"
                ></b-form-input>
              </b-form-group>

            </b-tab>

          </b-tabs>
          <div v-if="!isLoadingAttribute">
            <b-table-simple>
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Value</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tr
                v-for="(item, index) in fieldData.questionAttributes"
                :key="index"
              >
                <td>{{ item.key }}</td>
                <td>{{ item.value[transalationLanguage] }}</td>
                <td>
                  <font-awesome-icon
                    v-b-tooltip.hover
                    title="Delete Answer"
                    icon="trash"
                    :class="'ml-2 text-danger'"
                    @click="onDeleteData(index)"
                  />
                  <font-awesome-icon
                    v-b-tooltip.hover
                    title="Edit Answer"
                    class="ml-2 text-primary"
                    icon="edit"
                    @click="onEditData(item, index)"
                  />
                </td>
              </tr>
            </b-table-simple>
          </div>
        </b-tab>

      </b-tabs>
    </b-col>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Helper } from "../helpers";
import { EventBus } from "@/event-bus.js";
import _ from "lodash";

export default {
  name: "ExamQuestionSettings",
  props: {
    fieldData: Object,
    sectionIndex: Number,
    fieldIndex: Number,
  },
  components: {},
  data () {
    return {
      tempAnsValue: null,
      isLoading: false,
      isLoadedNewKeys: false,
      ansTempObje: null,
      transalationLanguage: "english",
      optionInputText: null,
      label: null,
      questionText: null,
      isCompulsory: 0,
      questionAnswer: null,
      questionAnswerIsCorrect: 0,
      questionAnswerOrderType: 1,
      selectedQuestionAnswerInputType: 1,
      selectedQuestionType: 1,
      optionsQuestionType: [
        {
          text: "Multiple Choice",
          value: 1,
        },
        {
          text: "Fill in the gaps",
          value: 2,
        },
        {
          text: "Free Text",
          value: 3,
        },
      ],
      questionTimeLimit: 0,
      questionScore: 1,
      selectedQuestionLevel: 1,
      optionsQuestionLevel: [
        {
          value: 1,
          text: "Basic",
        },
        {
          value: 2,
          text: "Intermediate",
        },
        {
          value: 3,
          text: "Advanced",
        },
        {
          value: 4,
          text: "Professional",
        },
        {
          value: 5,
          text: "Expert",
        },
      ],
      optionsQuestionAnswerInputType: [
        {
          value: 1,
          text: "Radio",
        },
        {
          value: 2,
          text: "Checkbox",
        },
      ],
      answers: [],
      fieldDataAttributeIndex: 0,
      questionAttributes: [],
      isLoadingAttribute: false,
      isEditingData: false,
      tempEditingData: null,
      selectingData: null,
      isEditingAnswer: false,
      selectedAnswerIndex: null,
      /* Background Image */
      isImageRequired:0,
      slideImg: null,
			file: null,
			imgUrl: null,
    };
  },

  mounted () {
    this.assignData();
    this.addExtras();
    // console.log("advancedsectionIndex", this.fieldData);
    this.questionText = this.fieldData.questionText[this.transalationLanguage];

    this.isCompulsory = this.fieldData.isCompulsory;
    this.questionTimeLimit = this.fieldData.questionTimeLimit;
    this.questionLevel = this.fieldData.questionLevel;
    this.questionScore = this.fieldData.questionScore;
    this.selectedQuestionType = this.fieldData.questionType;
    this.questionAnswerOrderType = this.fieldData.questionAnswerOrderType;
    this.answers = this.fieldData.answers;
    this.selectedQuestionAnswerInputType = this.fieldData.questionAnswerInputType;
    this.addLanguageKeys();

  // for background image
    this.isImageRequired = this.fieldData.isImageRequired;
    this.slideImg=this.fieldData.slideImg;
    this.imgUrl=this.fieldData.imgUrl;

  },

  created () {
    EventBus.$on( "onSaveSettings", ( value ) => {
      // this.addLanguageToField(this.transalationLanguage);
      this.updateAdvancedSettings();
      // Helper.makeToast(this.$bvToast, "success", "Settings Updated");
    } );
  },

  computed: {
    ...mapGetters( { form: "form1" } ),
  },

  methods: {
    /**
     * chnages the langugae in the modal for translations
     */

    addExtras () {
      this.isLoadedNewKeys = true;
      let self = this;
      if ( !this.fieldData.positiveMessage ) {
        this.fieldData.positiveMessage = { english: " " };

        // let positiveMessage = { english: " " };
        // Object.assign(this.fieldData, { positiveMessage });
      }
      if ( !this.fieldData.negativeMessage ) {
        this.fieldData.negativeMessage = { english: " " };
        // let questionWrongText = { english: "" };
        // Object.assign(this.fieldData, { questionWrongText });
      }
      if ( !this.fieldData.questionOptionalText ) {
        let questionOptionalText = { english: "" };
        Object.assign( this.fieldData, { questionOptionalText } );
      }
      setTimeout( function () {
        self.isLoadedNewKeys = false;
      }, 1000 );
    },

    tabClick ( language ) {
      console.log( "language", language );
      this.reset();
      this.transalationLanguage = language.toLowerCase();

      //this.label = this.fieldData.label[this.transalationLanguage];
    },

    addLanguageKeys () {
      if ( !this.fieldData.answerTitle ) {
        let answerTitle = { english: "" };
        Object.assign( this.fieldData, { answerTitle } );
      }
    },

    updateAdvancedSettings () {
      this.fieldData.isCompulsory = this.isCompulsory;
      this.fieldData.questionTimeLimit = this.questionTimeLimit;
      this.fieldData.questionLevel = this.questionLevel;
      this.fieldData.questionScore = this.questionScore;
      this.fieldData.questionType = this.selectedQuestionType;
      this.fieldData.questionAnswerOrderType = this.questionAnswerOrderType;
      this.fieldData.answers = this.answers;
      this.fieldData.questionAnswerInputType = this.selectedQuestionAnswerInputType;
      /*
          Background Image
      */
      this.fieldData.isImageRequired = this.isImageRequired;
      if(this.isImageRequired==false){
        this.slideImg=null;
        this.imgUrl=null;
        this.fieldData.slideImg=null;
        this.fieldData.imgUrl=null;
      }else{
        this.fieldData.slideImg=this.slideImg;
        this.fieldData.imgUrl=this.imgUrl;
      }


    },

    addLanguageToField ( language ) {
      let tempKey = language.toLowerCase();
      // this.fieldData.questionText[tempKey] = this.questionText;
    },

   addItemMultiChoice() {
      let tempObj = _.clone(this.fieldData.answerTitle);
      // this.questionAnswer
      if (this.tempAnsValue || this.ansTempObje) {
        if (this.isEditingAnswer) {
          this.ansTempObje[this.transalationLanguage] = this.tempAnsValue;
          this.answers[this.selectedAnswerIndex].isCorrectAnswer =
            this.questionAnswerIsCorrect == 1 ? "Yes" : "No";
        } else {
          tempObj[this.transalationLanguage] = this.tempAnsValue;
          var answer = {
            answer: tempObj,
            isCorrectAnswer: this.questionAnswerIsCorrect == 1 ? "Yes" : "No",
          };
          this.answers.push(answer);
        }
      }

      this.reset();
    },

    removeRowMultiChoice(index) {
      this.answers.splice(index, 1);
    },

    editAnswer(item, index, language) {
      // console.log("item, index", item, index, language);
      if (language in item.answer) {
        console.log("key Found");
        // do nothing..
      } else {
        console.log("key not found");
        item.answer = {
          ...item.answer,
          [language]: null,
        };
      }
      this.ansTempObje = item.answer;

      this.tempAnsValue = this.ansTempObje[language];
      this.questionAnswerIsCorrect = item.isCorrectAnswer == "Yes" ? "1" : "0";
      this.selectedAnswerIndex = index;
      this.questionAnswer = item.answer;

      this.isEditingAnswer = true;
    },

    // for background Image
    addBackgroundImg(value) {
        let imageFile = value;
        if (
          imageFile.type !== "image/jpeg" &&
          imageFile.type !== "image/png"
        ) {
          alert("You can only upload JPG and PNG file!");
        } else if (imageFile.size > 3769152) {
          alert("Image must smaller than 4MB!");
        } else if (imageFile) {
          this.getBase64(imageFile, imageUrl => {
            this.slideImg = imageFile;
            this.imgUrl = imageUrl;
            // console.log(this.slideImg);
            // console.log(this.imgUrl);
          });
        } else {
          alert("Image Error please try later");
        }
    },

    reset() {
      this.questionAnswer = null;
      this.questionAnswerIsCorrect = 0;
      this.tempAnsValue = null;
      this.isEditingAnswer = false;
    },
    assignData () {
      if ( this.fieldData.questionAttributes ) {
        return;
      } else {
        var values = { english: '' }
        this.form.formTranslations.map( item => {
          let value = item.toLowerCase();
          values[value] = null
          // values.append( value, null );
        } )
        let questionAttributes = [{ key: '', value: values }];
        Object.assign( this.fieldData, { questionAttributes } );
        console.log()
        // this.onSaveJsonData();
      }
    },

    addDataAttribute () {
      this.isLoadingAttribute = true;
      var values = { english: '' };
      // for ( let formTranslationValue of this.form.formTranslations ) {
      //   let value = formTranslationValue.toLowerCase();
      //   values.append( value, null );
      // }
      this.form.formTranslations.map( item => {
        let value = item.toLowerCase();
        values[value] = null
        // values.append( value, null );
      } )
      let questionAttributes = { key: '', value: values };
      this.fieldData.questionAttributes.push( questionAttributes );
      // console.log( 'this.transalationLanguage', this.transalationLanguage );
      this.fieldDataAttributeIndex = this.fieldData.questionAttributes.length - 1
      this.setTimeOutFunc()
      // this.onSaveJsonData();
    },

    onDeleteData ( index ) {
      this.isLoadingAttribute = true;

      // console.log( 'index', index );
      this.fieldData.questionAttributes.splice( index, 1 );
      this.fieldDataAttributeIndex = 0
      this.setTimeOutFunc()
    },
    onEditData ( item, index ) {
      this.fieldDataAttributeIndex = index
      // this.setTimeOutFun()
    },
    setTimeOutFunc () {
      this.isLoadingAttribute = true
      setTimeout( () => {
        this.isLoadingAttribute = false;
      }, 50 )
    },
    getBase64(img, callback) {
			const reader = new FileReader();
			reader.addEventListener("load", () => callback(reader.result));
			reader.readAsDataURL(img);
		},
  },
};
</script>
<style>
.cursor {
  cursor: pointer;
}
</style>

